import { render, staticRenderFns } from "./Bracket.vue?vue&type=template&id=5fee6ddc&scoped=true&"
import script from "./Bracket.vue?vue&type=script&lang=js&"
export * from "./Bracket.vue?vue&type=script&lang=js&"
import style0 from "./Bracket.vue?vue&type=style&index=0&id=5fee6ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee6ddc",
  null
  
)

export default component.exports